import Button from 'react-bootstrap/Button'
import Dropdown from 'react-bootstrap/Dropdown'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import React from 'react'
import { useTranslation } from 'react-i18next'
import LoadingSpinner from '../../../../../components/LoadingSpinner'
import { TransitEditorAction } from '../../../models/types'
import useDeclarationEditorActionRules from '../../components/useDeclarationEditorActionRules'
import { useDeclarationEditorContext } from '../../contexts/DeclarationEditorContext'

interface EnsEditorActionsProps {
  onAction: (action: TransitEditorAction) => void
  interactionsLocked: boolean
}

function EnsEditorActions({
  onAction,
  interactionsLocked,
}: Readonly<EnsEditorActionsProps>) {
  const { t } = useTranslation()
  const { declarationData } = useDeclarationEditorContext()
  const { isSubmitDisabled, isEnsPresentationNotificationAvailable } = useDeclarationEditorActionRules()

  const isNew = !declarationData?.transitOperation?.id

  const onSelect = (key: string | null) => {
    onAction(key as TransitEditorAction)
  }

  // const isLockedForNonAdmins = removePrefix(form.getValues().departureCustomsOffice, DEPARTURE_OFFICE_CODE_PREFIX)?.startsWith('PL') ? true : isSubmitButtonDisabled

  const isTest = process.env.REACT_APP_ENV !== 'live'

  return (
    <div className="d-flex align-items-center gap-2">
      <Dropdown align="end" as={ButtonGroup} onSelect={onSelect}>
        <Dropdown.Toggle id="dropdown-customs" variant="primary" size="sm" disabled={interactionsLocked}>
          {!interactionsLocked && <i className="fal fa-share" />}
          {interactionsLocked && <LoadingSpinner />}
          <span className="text-uppercase ms-2 pe-1">{t('buttons.customs')}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="shadow">
          <Dropdown.Item
            id="submit"
            eventKey="submit"
            disabled={isSubmitDisabled}
          >
            <i className="fal fa-file-alt me-2 fa-md" />
            <span className="text-uppercase">{t('buttons.submit')}</span>
          </Dropdown.Item>
          <Dropdown.Item
            id="amend"
            eventKey="amend"
            disabled
          >
            <i className="fal fa-file-edit me-2 fa-md" />
            <span className="text-uppercase">{t('buttons.amend')}</span>
          </Dropdown.Item>
          <Dropdown.Item id="cancel" eventKey="cancel" disabled>
            <i className="fal fa-file-times me-2 fa-md" />
            <span className="text-uppercase">{t('buttons.cancel')}</span>
          </Dropdown.Item>
          {isEnsPresentationNotificationAvailable ? (
            <Dropdown.Item id="ensPresentationNotification" eventKey="ensPresentationNotification">
              <i className="fal fa-reply me-2 fa-md" />
              <span className="text-uppercase">{t('buttons.ensPresentationNotification')}</span>
            </Dropdown.Item>
          ) : null}
          {isTest && (
            <>
              <Dropdown.Divider />
              <Dropdown.Item id="validate" eventKey="validate" disabled={isNew}>
                <i className="fal fa-clipboard-check me-2 fa-md" />
                <span className="text-uppercase">{t('declaration.headers.validate')}</span>
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
      <ButtonGroup>
        <Button
          id="saveDraft"
          variant="dark"
          size="sm"
          className="text-primary"
          type="button"
          disabled={interactionsLocked}
          onClick={() => onAction('saveDraft')}
        >
          {interactionsLocked && <LoadingSpinner />}
          <span className="ms-1">
            {t('buttons.saveDraft')}
          </span>
        </Button>
        <Dropdown align="end" as={ButtonGroup} onSelect={onSelect}>
          <Dropdown.Toggle
            id="dropdown-actions"
            variant="dark"
            size="sm"
            disabled={interactionsLocked}
          />
          <Dropdown.Menu className="shadow">
            <Dropdown.Item eventKey="duplicate" disabled={isNew}>
              <i className="fal fa-file-plus me-2 fa-md" />
              <span className="text-uppercase">{t('buttons.duplicate')}</span>
            </Dropdown.Item>
            <Dropdown.Item eventKey="createTransitFromEns" disabled={isNew}>
              <i className="fal fa-file-plus me-2 fa-md" />
              <span className="text-uppercase">{t('buttons.createTransitFromEns')}</span>
            </Dropdown.Item>
            <Dropdown.Item eventKey="pdf" disabled={isNew}>
              <i className="fal fa-file-pdf me-2 fa-md" />
              <span className="text-uppercase">{t('buttons.downloadPdf')}</span>
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item eventKey="createNew">
              <i className="fal fa-file me-2 fa-md" />
              <span className="text-uppercase">{t('buttons.createNew')}</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </ButtonGroup>
    </div>
  )
}

export default EnsEditorActions
